module.exports = __webpack_public_path__ + "static/media/photo9.41350f94.jpg";